import { useTheme } from "@mui/material";
import { FC } from "react";
import { ConfirmationDialog } from "../../../components";
import { useLocalization } from "../../../hooks/useLocalization";
import { AddNewUserSuccessDialogProps } from "./types";

export const AddNewUserSuccessDialog: FC<AddNewUserSuccessDialogProps> = ({
  isOpen,
  onClose,
  message,
  setMessage,
}) => {
  const { t } = useLocalization();
  const handleClose = () => {
    setMessage("");
    onClose();
  };

  const theme = useTheme();

  return (
    <ConfirmationDialog.Root
      aria-describedby="add-user-description"
      aria-labelledby="add-user-title"
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      open={isOpen}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
        },
      }}
    >
      <ConfirmationDialog.Title
        iconType="success"
        id="add-user-title"
        showIcon={true}
      >
        {t("users.addNewUserDialog.success")}
      </ConfirmationDialog.Title>
      <ConfirmationDialog.Content
        sx={{ fontWeight: 500, color: theme.colors.text[1] }}
      >
        {message}
      </ConfirmationDialog.Content>
      <ConfirmationDialog.Actions>
        <ConfirmationDialog.Button
          onClick={handleClose}
          sx={{ height: 40, borderRadius: "8px" }}
          variant="contained"
        >
          {t("users.addNewUserDialog.done")}
        </ConfirmationDialog.Button>
      </ConfirmationDialog.Actions>
    </ConfirmationDialog.Root>
  );
};
